import { differenceInHours, intlFormatDistanceWithOptions, isBefore, parseJSON } from 'date-fns/fp';
import { Timestamp } from '#components/atoms/timestamp/Timestamp.tsx';
import { useTime } from '#hooks/useTime.ts';

const THREE_MONTHS_HOURS = 2160;
const ONE_YEAR_HOURS = 8760;

type Props = {
  className?: string;
  lastSeenAt: string | undefined | null;
  createdAt: string;
};

// We enabled api key use tracking on Feb 10th, keys before this time may have been used untracked.
const STARTED_TRACKING_APIKEY_USE = parseJSON('2023-02-10T17:00:00Z');

export function LastSeenAt({ className, lastSeenAt, createdAt }: Props) {
  const currentTime = useTime();

  if (!lastSeenAt && isBefore(STARTED_TRACKING_APIKEY_USE, parseJSON(createdAt))) {
    return <span className={className}>Unknown</span>;
  }

  if (!lastSeenAt) {
    return <span className={className}>Never</span>;
  }

  const hours = differenceInHours(parseJSON(lastSeenAt), currentTime);

  if (hours < 24) {
    return (
      <Timestamp className={className} datetime={lastSeenAt}>
        within 24 hours
      </Timestamp>
    );
  }

  // By default, intlFormatDistance will use `quarters` or `q`, which is an awkward unit.  Let's just force months instead.
  const forceMonths = hours >= THREE_MONTHS_HOURS && hours <= ONE_YEAR_HOURS;

  return (
    <Timestamp className={className} datetime={lastSeenAt}>
      {intlFormatDistanceWithOptions({ unit: forceMonths ? 'month' : undefined }, currentTime, parseJSON(lastSeenAt))}
    </Timestamp>
  );
}
